import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { SelectStakingWalletPage } from './select-staking-wallet.page';

const routes: Routes = [
  {
    path: '',
    component: SelectStakingWalletPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SelectStakingWalletPage]
})
export class SelectStakingWalletPageModule {}
